import { useQueryClient } from 'react-query'
import styled from 'styled-components'
import { t } from 'ttag'

import { Page } from '@h2/common/components/page'
import { Flex } from '@h2/components/layout/flex'
import { FileUploadHandler } from '@h2/components/containers/fileUploadHandler'
import { FileDragAndDrop } from '@h2/components/containers/fileDragAndDrop'
import { features } from '@h2/components/media'
import { usePageTitle } from '@h2/common/components/hooks/usePageTitle'

import { Activities } from './components/activities'
import { Research } from './components/research'
import { LocalOpportunities } from './components/localOpportunities'
import { Recommendations } from './components/recommendations'
import { RecommendedNextStep } from './components/recommendedNextStep'
import { CareerHubOverview } from './components/careerHubOverview'

import { Feed } from '../feed'
import { Account } from '../account'

const StyledPage = styled(Page)`
  > .Explorer-Dashboard-Layout {
    @media (${features.maxWidth.desktop}) {
      grid-template-areas:
        'cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt cnt'
        'btm btm btm btm btm btm btm btm btm btm btm btm';

      > .Explorer-Dashboard-SideBar {
        display: none;
      }
    }
  }

  .Explorer-Dashboard-Account {
    margin-bottom: 0;
  }
`
const Links = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 20px;
  flex-wrap: wrap;

  > div {
    @media (${features.minWidth.desktop}) {
      max-width: calc(33% - 20px);
    }
  }
`
const Explorer = () => {
  const queryClient = useQueryClient()
  const numPerPage = 5

  usePageTitle(t`Explorer Dashboard`)

  return (
    <StyledPage>
      <Page.Layout className="Explorer-Dashboard-Layout">
        <Page.Content>
          <Flex wrap="wrap" margin="0 0 20px 0" gap="20px">
            <RecommendedNextStep />
            <Account isInFlex={true} className="Explorer-Dashboard-Account" />
          </Flex>
          <FileUploadHandler
            uploadUrl={'/api/v2/files'}
            onSuccess={() => {
              queryClient.refetchQueries(['careerhub-feed', numPerPage], {
                refetchType: 'all'
              })
            }}>
            {({ uploadHandler, progress, isUploading }) => (
              <FileDragAndDrop
                uploadProgress={progress}
                isUploading={isUploading}
                uploadHandler={uploadHandler}>
                <CareerHubOverview numPerPage={numPerPage} />
              </FileDragAndDrop>
            )}
          </FileUploadHandler>
        </Page.Content>
        <Page.Sidebar className="Explorer-Dashboard-SideBar">
          <Feed />
        </Page.Sidebar>
        <Page.Bottom className="Explorer-Dashboard-Bottom">
          <Recommendations />
          <Links>
            <Activities />
            <Research />
            <LocalOpportunities />
          </Links>
        </Page.Bottom>
      </Page.Layout>
    </StyledPage>
  )
}

export { Explorer }
